import { Injectable } from '@angular/core';
import { Terminal } from 'src/app/models/terminal';
import { AuthService } from '@app/services/auth.service';
import { Firestore } from '@angular/fire/firestore';
import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class TerminalService {

  constructor(
    private firestore: Firestore,
    public auth: AuthService
  ) { }
  async getTerminals(): Promise<Terminal[]> {
    const snapshot = await getDocs(collection(this.firestore, 'terminals'));
    const terminals = snapshot.docs.map(x => {
      const data = x.data();
      const terminal = Object.assign({}, data as Terminal);
      terminal.id = x.id;
      if (terminal.isPWA === undefined) {
        terminal.isPWA = false;
      }
      return terminal;
    });

    return Promise.resolve(terminals);
  }

  getTerminal(serialId: string): Promise<Terminal> {
    return new Promise<Terminal>(async (resolve, reject) => {
      let count = 0;
      const terminalQuery = query(collection(this.firestore, 'terminals'), where('serialId', '==', serialId));
      const snapShot = await getDocs(terminalQuery);
      count = snapShot.size;
      if (count === 1) {
        const terminal = (Object.assign({}, snapShot.docs[0].data()) as Terminal);
        terminal.id = snapShot.docs[0].id;
        if (terminal.isPWA === undefined) {
          terminal.isPWA = false;
        }
        resolve(terminal);
      } else {
        reject();
        return;
      }
    });
  }

  async delete(target: Terminal) {
    await deleteDoc(doc(this.firestore, 'terminals', target.id.toString()));
    // serialIdの削除
    if (target.isPWA) {
      const serialId = localStorage.getItem('serialId');
      if (serialId) {
        if (serialId === target.serialId) {
          localStorage.removeItem('serialId');
        }
      }
    }
  }

  isPWATerminal(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      let count = 0;
      const serialId = localStorage.getItem('serialId');

      if (serialId) {
        try {
          const terminalQuery = query(collection(this.firestore, 'terminals'), where('serialId', '==', serialId));
          const snapShot = await getDocs(terminalQuery);
          count = snapShot.size;
          // ユニークなシリアルIDならば
          console.log(serialId);
          if (count === 1) {
            resolve(snapShot.docs[0].get('isPWA'));
          } else {
            resolve(false);
          }
        } catch (err) {
          reject(err);
          return;
        }
      } else {
        resolve(false);
      }
    });
  }
}
